import SectionIntro from "./SectionIntro";
import { changelog } from "@/mocks/softwareData";

export default function Changelog() {
  return (
    <section id="log" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.2fr]">
          {/* 说明栏 */}
          <div>
            <SectionIntro
              eyebrow="THIS WEEK"
              title="本周更新速报"
              desc="版本上线、专题上新与安全校验进度都在这里滚动更新，看清每一次变化。"
            />
            <div className="mt-6 rounded-xl border border-background-200 bg-background-50 p-5">
              <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-check-line"></i>
                </span>
                全站安装包健康
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                本周对站内 46 个安装包完成扫描，未发现风险项，签名证书与指纹库均已同步至最新版本。
              </p>
              <a
                href="#guide"
                className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
              >
                查看安全校验说明 <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          {/* 时间轴 */}
          <div className="relative pl-6">
            <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300/70"></span>
            <ul className="space-y-5">
              {changelog.map((item) => (
                <li key={item.date + item.text} className="relative">
                  <span className="absolute -left-6 top-1.5 h-3.5 w-3.5 rounded-full border-2 border-background-100 bg-primary-500"></span>
                  <div className="rounded-xl border border-background-200 bg-background-50 px-4 py-3.5">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="whitespace-nowrap text-xs font-semibold text-foreground-400">{item.date}</span>
                      <span
                        className={`rounded px-1.5 py-0.5 text-xs font-semibold ${
                          item.type === "安全"
                            ? "bg-accent-100 text-accent-700"
                            : item.type === "专题"
                              ? "bg-secondary-100 text-secondary-700"
                              : "bg-primary-100 text-primary-600"
                        }`}
                      >
                        {item.type}
                      </span>
                      <span className="text-sm font-semibold text-foreground-900">{item.app}</span>
                      {item.version !== "—" && (
                        <span className="whitespace-nowrap rounded bg-background-200 px-1.5 py-0.5 text-xs text-foreground-600">
                          v{item.version}
                        </span>
                      )}
                    </div>
                    <p className="mt-1.5 text-sm text-foreground-600">{item.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}